import React, { useState } from "react";
import { Lock, MapPin } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export const guestKeyFor = (slug) => localStorage.getItem(`lif_guest_${slug}`) || "";
export const rememberGuest = (slug, id) => id && localStorage.setItem(`lif_guest_${slug}`, id);

export function VenueDetail({ w, slug, onUnlocked }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  async function unlock(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/public/weddings/${slug}/venue-unlock`, { email });
      rememberGuest(slug, data.guest_key);
      toast.success("Welcome! Here's where to find us.");
      onUnlocked();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }
  if (!w.venue && !w.venue_hidden) return null;
  return (
    <div data-testid="venue-detail">
      <MapPin className="w-6 h-6 text-[var(--gold)] mx-auto mb-3" />
      <h3 className="font-serif text-2xl mb-2">Venue</h3>
      {w.venue_hidden ? (
        <>
          <p className="text-[var(--muted)] flex items-center justify-center gap-1.5" data-testid="venue-private"><Lock className="w-3.5 h-3.5" /> Shared privately with our guests</p>
          {w.city && <p className="text-[var(--muted)]">{w.city}</p>}
          {!open ? (
            <button onClick={() => setOpen(true)} className="text-xs text-[var(--gold)] underline mt-3" data-testid="venue-unlock-toggle">On the guest list? See the venue</button>
          ) : (
            <form onSubmit={unlock} className="mt-3 flex gap-2 max-w-xs mx-auto">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="input-luxe !py-2 text-sm" data-testid="venue-unlock-email" />
              <button disabled={busy} className="btn-gold !py-2 !px-4 text-xs" data-testid="venue-unlock-submit">{busy ? "…" : "Unlock"}</button>
            </form>
          )}
        </>
      ) : (
        <>
          <p className="text-[var(--muted)]" data-testid="venue-name">{w.venue}</p>
          {w.city && <p className="text-[var(--muted)]">{w.city}</p>}
        </>
      )}
    </div>
  );
}
